import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FundingModel } from '@bp-core/src/lib/proto/common-message.pb';
import { fuseAnimations } from '@fuse/animations';
import { IChart } from 'projects/bp-core/src/lib/models/portal/chart.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-g-p-p-e-table',
  templateUrl: './g-p-p-e-table.component.html',
  styleUrls: ['./g-p-p-e-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: fuseAnimations,
  standalone: true,
  imports: [
    MatButtonToggleModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatMenuModule,
    MatIconModule,
  ],
})
export class GPPETableComponent implements OnInit, OnDestroy, AfterViewInit {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  @Input()
  lessThanAYear: boolean;
  @Input()
  profitabilities: IChart;

  @Input() portfolioFunds: FundingModel[] | undefined;
  @Input() comparatorUSDFunds: FundingModel[] | undefined;
  @Input() comparatorCLPFunds: FundingModel[] | undefined;
  @Input() comparativeFundsSelected: number[] | undefined;

  @Output()
  changeComparative = new EventEmitter<number[]>();
  options = {
    allTime: 'Acumulada',
    pastYearReturn: 'Anualizada',
  };
  optionsArray = Object.entries(this.options);

  valueSelected: 'pastYearReturn' | 'allTime' = 'allTime';
  comparativeControl = new FormControl([0]);

  constructor() {}

  ngAfterViewInit(): void {
    console.log(this.profitabilities);
  }
  selectOption(option: any) {
    this.valueSelected = option;
  }

  ngOnInit() {
    if (this.comparativeFundsSelected) {
      this.comparativeControl.setValue(this.comparativeFundsSelected);
    } else {
      this.comparativeControl.setValue([0]);
    }

    this.comparativeControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      //console.log('valor:', value);
      this.changeComparative.emit(value!);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }
}
